module.exports = __webpack_public_path__ + "static/media/dashboardandroid.30445c20.png";